import { render, staticRenderFns } from "./DxMonitoringOthers.vue?vue&type=template&id=78b0cbf8&"
import script from "./DxMonitoringOthers.vue?vue&type=script&lang=js&"
export * from "./DxMonitoringOthers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports